import { z } from 'zod';

export const schedulingStepFormSchema = z
  .object({
    kinnser_create_episode: z.boolean().nullable().optional(),
    roger_create_episode: z.boolean().nullable().optional(),

    // Push to EMR flags
    push_to_kinnser: z.boolean().nullable().optional(),
    push_to_roger: z.boolean().nullable().optional(),

    // Kinnser Episode and SOC fields
    kinnser_type_of_soc: z.string().nullable().optional(),
    kinnser_soc_date: z.string().nullable().optional(),
    kinnser_episode_start_date: z.string().nullable().optional(),

    // Kinnser Clinician assignment fields
    kinnser_clinician_id: z.string().nullable().optional(),
    kinnser_clinical_care_manager_id: z.string().nullable().optional(),
    kinnser_case_manager_id: z.string().nullable().optional(),
    kinnser_oasis_approver_id: z.string().nullable().optional(),
    kinnser_pt_approver_id: z.string().nullable().optional(),
    kinnser_ot_approver_id: z.string().nullable().optional(),
    kinnser_st_approver_id: z.string().nullable().optional(),

    // Kinnser Scheduler assignment fields
    kinnser_primary_scheduler_id: z.string().nullable().optional(),
    kinnser_secondary_scheduler_id: z.string().nullable().optional(),

    // Roger Episode and SOC fields
    roger_type_of_soc: z.string().nullable().optional(),
    roger_soc_date: z.string().nullable().optional(),
    roger_episode_start_date: z.string().nullable().optional(),

    // Roger Clinician assignment fields
    roger_clinician_id: z.string().nullable().optional(),
    roger_case_manager_id: z.string().nullable().optional(),
  })
  .superRefine((data, ctx) => {
    // Episode fields are required when Kinnser Create Episode is enabled
    if (data.kinnser_create_episode === true) {
      if (
        !data.kinnser_clinician_id ||
        data.kinnser_clinician_id.length === 0
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Clinician is required',
          path: ['kinnser_clinician_id'],
        });
      }
      if (
        !data.kinnser_clinical_care_manager_id ||
        data.kinnser_clinical_care_manager_id.length === 0
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Clinical Care Manager is required',
          path: ['kinnser_clinical_care_manager_id'],
        });
      }
      if (
        !data.kinnser_case_manager_id ||
        data.kinnser_case_manager_id.length === 0
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Case Manager is required',
          path: ['kinnser_case_manager_id'],
        });
      }
      if (
        !data.kinnser_oasis_approver_id ||
        data.kinnser_oasis_approver_id.length === 0
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'OASIS Approver is required',
          path: ['kinnser_oasis_approver_id'],
        });
      }
      if (
        !data.kinnser_pt_approver_id ||
        data.kinnser_pt_approver_id.length === 0
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'PT Approver is required',
          path: ['kinnser_pt_approver_id'],
        });
      }
      if (
        !data.kinnser_ot_approver_id ||
        data.kinnser_ot_approver_id.length === 0
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'OT Approver is required',
          path: ['kinnser_ot_approver_id'],
        });
      }
      if (
        !data.kinnser_st_approver_id ||
        data.kinnser_st_approver_id.length === 0
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'ST Approver is required',
          path: ['kinnser_st_approver_id'],
        });
      }
      if (!data.kinnser_type_of_soc || data.kinnser_type_of_soc.length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Type of SOC is required',
          path: ['kinnser_type_of_soc'],
        });
      }
      if (!data.kinnser_soc_date || data.kinnser_soc_date.length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Start of Care Date is required',
          path: ['kinnser_soc_date'],
        });
      }
      if (
        !data.kinnser_episode_start_date ||
        data.kinnser_episode_start_date.length === 0
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Episode Start Date is required',
          path: ['kinnser_episode_start_date'],
        });
      }
    }

    // Episode fields are required when Roger Create Episode is enabled
    if (data.roger_create_episode === true) {
      if (
        !data.kinnser_clinician_id ||
        data.kinnser_clinician_id.length === 0
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Clinician is required',
          path: ['kinnser_clinician_id'],
        });
      }
      if (
        !data.kinnser_case_manager_id ||
        data.kinnser_case_manager_id.length === 0
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Case Manager is required',
          path: ['kinnser_case_manager_id'],
        });
      }
      if (!data.roger_type_of_soc || data.roger_type_of_soc.length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Type of SOC is required',
          path: ['roger_type_of_soc'],
        });
      }
      if (!data.kinnser_soc_date || data.kinnser_soc_date.length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Start of Care Date is required',
          path: ['kinnser_soc_date'],
        });
      }
      if (
        !data.kinnser_episode_start_date ||
        data.kinnser_episode_start_date.length === 0
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Episode Start Date is required',
          path: ['kinnser_episode_start_date'],
        });
      }
    }
  });

export type SchedulingStepFormData = z.infer<typeof schedulingStepFormSchema>;
